import { api } from '@/lib/utils/axios'
import { IPostMyApplicationsCancelParams } from '../_type'

interface postUserInfoParams {
  is_email_marketing_agreed?: boolean
  is_sms_marketing_agreed?: boolean
}

export const getUserInfo = async () => {
  const res = await api.get('/front/v1/auth/users/info')
  return res.data
}

export const patchUserInfo = async ({ params }: { params: postUserInfoParams }) => {
  const res = await api.patch('/front/v1/auth/users/info', {
    ...params,
  })
  return res.data
}

export const postChangePassword = async ({ password }: { password: string }) => {
  const res = await api.post('/front/v1/auth/users/change-password', {
    password,
  })
  return res.data
}

export const getPrograms = async ({
  page,
  limit,
  sort,
  filters,
}: {
  page: number
  limit: number
  sort?: string
  filters?: string
}) => {
  const res = await api.get('/front/v1/programs/programs', {
    params: {
      page,
      limit,
      ...(sort && { sort }),
      ...(filters && { filters }),
    },
  })
  return res.data
}

export const getMyApplications = async ({
  page,
  limit,
  sort,
  filters,
  application_status,
}: {
  page: number
  limit: number
  sort?: string
  filters?: string
  application_status?: string
}) => {
  const res = await api.get('/front/v1/programs/applications/my', {
    params: {
      page,
      limit,
      ...(sort && { sort }),
      ...(filters && { filters }),
      ...(application_status && { application_status }),
    },
  })
  return res.data
}

export const postMyApplicationsCancel = async ({
  submission_id,
  reason,
}: IPostMyApplicationsCancelParams) => {
  const res = await api.post(`/front/v1/programs/applications/${submission_id}/cancel`, {
    reason,
  })
  return res.data
}
